import React from 'react';
import Navbar from '../Navbar';
import Hero from './Hero';
import Awards from './Awards';
import Stats from './Stats';
import Pricing from './pricing';
import Eduction from './Education';
import OpenAccount from '../OpenAccount';
import Footer from '../Footer';
function HomePage() {
    return ( 
        <>
        <Hero/>
        <Awards/>
        <Stats/>
        <Pricing/>
        <Eduction/>
        <OpenAccount/>
        </>
     );
}
<h1></h1>

export default HomePage;